<h1 class="title">
    {{lblPageTitle}}
    <span *ngIf="idVehicle" class="fs-13 push-right">
        <span class="title-badge sold" *ngIf="vehicle.VehicleStatus == 'Vendido'">vendido</span>
        <span class="title-badge inactive" *ngIf="vehicle.VehicleStatus == 'Inativo'">inativo</span>
        <span class="color-gray">Criado em</span> {{vehicle.CreationDate}}
    </span>
</h1>
<div class="form">
    <div class="row">
        <div class="col-md-4">
            <label class="mandatory lbl">Fabricante</label>
            <input type="text" name="manufacturer" placeholder="Fabricante" value="" [(ngModel)]="vehicle.Manufacturer" />
        </div>
        <div class="col-md-4">
            <label class="mandatory lbl">Nome</label>
            <input type="text" name="name" placeholder="Nome" value="" [(ngModel)]="vehicle.Name" />
        </div>
        <div class="col-md-4">
            <label class="mandatory lbl">Modelo</label>
            <input type="text" name="model" placeholder="Modelo" value="" [(ngModel)]="vehicle.Model" />
        </div>
    </div>
    <div class="row">
        <div class="col-md-4">
            <label class="mandatory lbl">Ano</label>
            <input type="text" name="Year" placeholder="Ano" value="" [(ngModel)]="vehicle.Year" />
        </div>
        <div class="col-md-4">
            <label class="mandatory lbl">KM</label>
            <input type="text" name="Km" placeholder="KM" value="" [(ngModel)]="vehicle.Km" mask="separator.3" />
        </div>
        <div class="col-md-4">
            <label class="mandatory lbl">Câmbio</label>
            <input type="text" name="Gearbox" placeholder="Câmbio" value="" [(ngModel)]="vehicle.Gearbox" />
        </div>
    </div>
    <div class="row">
        <div class="col-md-4">
            <label class="mandatory lbl">Combustível</label>
            <input type="text" name="Fuel" placeholder="Combustível" value="" [(ngModel)]="vehicle.Fuel" />
        </div>
        <div class="col-md-4">
            <label class="mandatory lbl">Cor</label>
            <input type="text" name="Color" placeholder="Cor" value="" [(ngModel)]="vehicle.Color" />
        </div>
        <div class="col-md-4">
            <label class="mandatory lbl">Final da placa</label>
            <input type="text" name="LicensePlate" placeholder="Final da placa" value="" [(ngModel)]="vehicle.LicensePlate" />
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <label class="mandatory lbl">Imagem principal</label>
            <input type="text" name="FeatureImage" placeholder="Imagem principal" value="" [(ngModel)]="vehicle.FeatureImage" />
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <label class="mandatory lbl">Observações</label>
            <textarea rows="4" name="Observations" placeholder="Observações" value="" [(ngModel)]="vehicle.Observations"></textarea>
        </div>
    </div>
    <h2 class="subtitle m-t-75">
        Fotos
        <span *ngIf="vehicle.FeatureImage && !idVehicle" class="color-orange fs-13 m-l-10">Salve o veículo para adicionar mais fotos.</span>
        <i *ngIf="idVehicle" class="fas fa-plus-circle icon-sub-title push-right" (click)="toggleInputNewVehicleImage()"></i>
    </h2>
    <div class="row" *ngIf="showInputNewVehicleImage">
        <div class="col-md-9">
            <label class="lbl">Nova fota</label>
            <input type="text" placeholder="URL da nova foto do veículo" [(ngModel)]="vehicleImage.ImageURL" />
        </div>
        <div class="col-md-3 text-right">
            <a (click)="saveVehicleImage()" class="btn btn-primary" style="margin-top:22px;">Adicionar imagem</a>
        </div>
    </div>
    <span *ngIf="!vehicle.FeatureImage && !idVehicle" class="color-gray">Nenhuma foto cadastrada para esse veículo.</span>
    <div class="vehicle-details-images">
        <div *ngIf="vehicle.FeatureImage" class="img-block feature">
            <img class="vehicle-details-image" src="{{vehicle.FeatureImage}}" title="Foto principal" />
            <div>
                <i class="far fa-trash-alt delete-icon" title="Remover imagem" (click)="deleteFeatureImage()"></i>&nbsp;&nbsp;&nbsp;<i title="Imagem principal" class="fas fa-star color-yellow"></i>
            </div>
        </div>
        <div *ngFor="let img of vehicleImages; let i = index" class="img-block {{ img.Class }}">
            <img class="vehicle-details-image {{img.Class}}" src="{{img.ImageURL}} " title="Foto {{i + 1}}" />
            <i *ngIf="img.Class != 'feature'" title="Remover imagem" class="far fa-trash-alt delete-icon" (click)="deleteVehicleImage(img.IdVehicleImage)"></i>
        </div>
    </div>
    <h2 class="subtitle m-t-75">Dados financeiros</h2>
    <div class="row">
        <div class="col-md-4">
            <label class="mandatory lbl">Valor de custo</label>
            <input type="text" name="CostPrice" placeholder="Valor de custo" value="" [(ngModel)]="vehicle.CostPrice" prefix="R$ " mask="separator.3" />
        </div>
        <div class="col-md-4">
            <label class="mandatory lbl">Valor de venda</label>
            <input type="text" name="SaleValue" placeholder="Valor de venda" value="" [(ngModel)]="vehicle.SaleValue" prefix="R$ " mask="separator.3" />
        </div>
        <div class="col-md-4"></div>
    </div>
    <h2 class="subtitle m-t-75">Configurações do anúncio</h2>
    <div class="row">
        <div class="col-md-4">
            <label class="mandatory lbl">Status</label>
            <select name="Active" [(ngModel)]="vehicle.IdVehicleStatus">
                <option value="1">Ativo</option>
                <option value="2">Inativo</option>
                <option value="3">Vendido</option>
            </select>
        </div>
        <div class="col-md-4">
            <label class="mandatory lbl">Destaque</label>
            <select name="Feature" [(ngModel)]="vehicle.Feature">
                <option value="true">Sim</option>
                <option value="false">Não</option>
            </select>
        </div>
        <div class="col-md-4">
            <label class="lbl">Texto do destaque</label>
            <input type="text" name="FeatureLabel" placeholder="Texto do destaque" value="" [(ngModel)]="vehicle.FeatureLabel" />
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="form-buttons">
                <label class="lbl-creation-date">
                    <b *ngIf="idVehicle">Criado em <span class="color-primary">{{vehicle.CreationDate}}</span></b>
                </label>
                <a (click)="saveVehicle()" class="btn btn-primary">{{lblButtonText}}</a>
            </div>
        </div>
    </div>
</div>
<br />
<br />
